import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="wizard"
export default class extends Controller {
  handleSubmit(event) {
    // We want to update data-turbo-transition attribute depending on the button pressed
    // We need to do this before the form is submitted
    const button = event.submitter;
    if (button.value === "back") {
      this.element.dataset.turboTransition = "wizard-back";
    } else {
      this.element.dataset.turboTransition = "wizard";
    }
  }
}
